/**
 * Singleton service instances.
 * Import these instead of doing `new XService()` in components/hooks.
 */
import { ReportService } from './reportService';
import { SweepService } from './sweepService';
import { UserService } from './userService';
import { PlayerService } from './playerService';

export const reportService = new ReportService();
export const sweepService = new SweepService();
export const userService = new UserService();
export const playerService = new PlayerService();
